import { defineMessages } from 'react-intl';

export default defineMessages({
  deposit: 'Deposit',
  borrowed: 'Borrowed',
  withdrawal: 'Withdrawal',
  repayment: 'Repayment',
  changeOfAPYType: 'Change of APY Type',
  changeOfUsageAsCollateral: 'Change of usage as collateral',
  liquidation: 'Liquidation',

  download: 'Download .CSV',
});
